<script lang="ts">
import { computed, defineComponent } from "vue";
import formatUtils from "@/businesslogic/utils/formatUtils";
import storeUtils from "@/businesslogic/utils/storeUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "TarifauswahlEineLinie",
  props: {
    produktbezeichnung: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const piniaStore = useFormStore();
    const { formatCurrency } = formatUtils();
    const { istFhkVerkaufsprodukt } = storeUtils();

    const gesamtPreisEinmalig = computed(() => {
      return piniaStore.state.preise.produktLinien.length > 0 ? piniaStore.state.preise.produktLinien[0].einmalig : 0;
    });

    const gesamtPreisFH = computed(() => {
      return piniaStore.state.preise.produktLinien.length > 0
        ? piniaStore.state.preise.produktLinien[piniaStore.state.preise.produktLinien.length - 1].gemZahlungsweise
        : 0;
    });

    return {
      props,
      piniaStore,
      gesamtPreisEinmalig,
      gesamtPreisFH,
      formatCurrency,
      istFhkVerkaufsprodukt,
    };
  },
});
</script>

<template>
  <div class="o-grid">
    <div
      class="o-grid__cell o-grid__cell--12 o-grid__cell--offset-0 o-grid__cell--9-480 o-grid__cell--offset-3-480 o-grid__cell--8-768 o-grid__cell--offset-3-768 o-grid__cell--7-1024 o-grid__cell--6-1200"
    >
      <div id="tariffHeader" class="one-col__tariff">
        <div class="one-col__tariff-label">{{ piniaStore.state.isMakler ? "" : "Ihr " }}Tarif</div>
        <svg viewBox="0 0 830 160" aria-hidden="true">
          <polygon points="2,2 828,2 828,120 415,150 2,120"></polygon>
        </svg>
        <div v-if="istFhkVerkaufsprodukt(piniaStore.state)" class="one-col__tariff-name-price">
          {{ props.produktbezeichnung }}<br />
          {{ formatCurrency(gesamtPreisFH) }}
        </div>
        <div v-else class="one-col__tariff-name-price">
          {{ props.produktbezeichnung }}<br />
          {{ formatCurrency(gesamtPreisEinmalig) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
